import Dexie from 'dexie';

// Configuration de la base de données
export class OSCMysqlDatabase extends Dexie {
  constructor() {
    super('OSC_MysqlDB');
    
    // Version 4 : Ajout de la table administrators
    this.version(4).stores({
      registrations: '++id, email, phone, businessName, createdAt, lastModified, status',
      administrators: '++id, username, password, role, email, lastLogin, createdAt'
      // Autres tables à venir...
      // users: '++id, email, name, role',
      // products: '++id, name, price, category'
    });
  }
}

// Instance unique de la base de données
export const db = new OSCMysqlDatabase(); 